const stateTypes = {};

const getterTypes = {
  LandingApi: 'LandingApiGetter'
};

const mutationTypes = {};

const actionTypes = {
  leaveComment: 'leaveCommentAction',
  getHtmlContent: 'getHtmlContentAction',
};

export { stateTypes, getterTypes, mutationTypes, actionTypes };
